module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOptions,
      "auto-update": _vm.autoUpdate
    }
  }, [_vm._l((_vm.images), function(img, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticClass: "slide-img",
      attrs: {
        "src": _vm.constructImageURL(img)
      }
    }), _vm._v(" "), (_vm.isShowDelete) ? _c('span', {
      staticClass: "del-image",
      on: {
        "click": function($event) {
          return _vm.$emit('delete', index)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-104df822"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/ImageSwiper.vue
// module id = 2006
// module chunks = 0